import Stack from "@mui/material/Stack";
import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import { MainText } from "../../data/style/Style";
import useScreenSize from "../../context/ScreenContext";
import { getWorkoutPerformanceStatistics } from "../../api/workouts";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ReferenceLine,
  Cell,
  ResponsiveContainer,
} from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    var data = payload[0].payload;
    return (
      <Stack
        p={1}
        sx={{
          background: Theme.palette.card,
          border: 1,
          borderColor: Theme.palette.orange,
          width: "200px",
          borderRadius: 4,
        }}
        gap={1}
      >
        <MainText>Period:&nbsp;{data.date}</MainText>
        <MainText>Percentage:&nbsp;{data.percentage}%</MainText>
      </Stack>
    );
  }

  return null;
};
const WorkoutPerformanceChart = (props) => {
  let { dateRange, type } = props;
  let { user } = useAuth();
  const { size } = useScreenSize();
  var [width] = size;

  const { data, isPending } = useQuery({
    queryKey: [
      "workouts",
      "performance",
      "statistics",
      user.id,
      type,
      dateRange,
    ],
    queryFn: ({ signal }) =>
      getWorkoutPerformanceStatistics({ type, dateRange, signal }),
    staleTime: 30 * 60 * 1000,
  });

  const axisClass = {
    fill: Theme.palette.muted,
    fontSize: width < 750 ? "9px" : "0.7rem",
    fontFamily: "DM Sans, sans-serif",
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      {!isPending && (
        <BarChart margin={{ left: -30, right: 15 }} data={data}>
          <XAxis tick={axisClass} dataKey="date" />
          <YAxis tick={axisClass} />
          <Tooltip
            cursor={{ fill: "transparent" }}
            content={<CustomTooltip />}
          />
          <ReferenceLine y={0} stroke={Theme.palette.muted} />
          <Bar
            dataKey="percentage"
            barSize={data > 10 || width < 750 ? 15 : 20}
            fill={(value) => console.log(value)}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={
                  entry.percentage >= 0 ? Theme.palette.up : Theme.palette.down
                }
              />
            ))}
          </Bar>
        </BarChart>
      )}
    </ResponsiveContainer>
  );
};

export default WorkoutPerformanceChart;
